<template>
  <div v-if="isAdminRoute" class="header-wrapper row m-0">
    <Logo/>
  </div>

  <div v-else class="header-wrapper header-wrapper-driver m-0">
    <DriverHeader/>
    <div class="logo-container">
        <RouterLink to="/">
          <img src="@/assets/images/driver/logo.png" class="logo"/>
        </RouterLink>
    </div>
  </div>
</template>


<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Logo from './logo.vue';
import DriverHeader from './driverHeader.vue';

export default { 
  components: {
    Logo,
    DriverHeader
  },
  setup() {
    const route = useRoute();
    const isAdminRoute = computed(() => route.path.includes('/admin'));

    return {
      isAdminRoute
    };
  }
};
</script>

<style scoped>
.header-wrapper {
  position: relative;
  width: 100%; /* 確保父容器佔滿寬度 */
  padding: 0px !important;
}

.header-wrapper-driver {
  display: none;
  align-items: center;
  justify-content: flex-start; /* 預設將內容靠左 */
  background-color: #eef1f4;
  position: relative; /* 使絕對定位的 logo 可以依據此容器定位 */
  height: 80px; /* 設置一個固定高度 */
}

.logo-container {
  position: absolute; /* 絕對定位 */
  left: 50%; /* 移至中央 */
  transform: translateX(-50%); /* 精確居中調整 */
  display: flex;
  align-items: center;
}

.logo {
  height: 32px;
  width: 96px;
}

@media (max-width: 992px) {
  .header-wrapper, .header-wrapper-driver {
    padding: 15px !important;
  }
  .header-wrapper-driver{
    display: flex;
  }
}
</style>

